import {
  Validators,
  AbstractControl,
  ValidatorFn,
  ValidationErrors,
} from '@angular/forms';

import { isPresent } from '../utils/is-present';

export const mobileOrLandline: ValidatorFn = (
  control: AbstractControl
): ValidationErrors => {
  if (isPresent(Validators.required(control))) {
    return null;
  }

  const v: string = control.value;
  return /^(07[\d]{9}|0[\d]{8,10})$/g.test(v)
    ? null
    : { mobileOrLandline: true };
};
